import { baseAPI } from '~shared/api/base-api';
import { type ExportFormat, KEYS } from '~shared/api/query-keys';

import type { BirthdayStatusFilter } from './reporting-birthdays';

interface ReportingStudentsByAgeParams {
  status?: BirthdayStatusFilter;
  // Optional "as of" date (yyyy-MM-dd) — adds as-of age columns and is used
  // as the reference date for minAge/maxAge filtering.
  ageAsOf?: string;
  minAge?: number;
  maxAge?: number;
  format?: ExportFormat;
}

export const reportingStudentsByAgeAPI = async ({
  status = 'all',
  ageAsOf,
  minAge,
  maxAge,
  format = KEYS.EXPORT_FORMAT.CSV,
}: ReportingStudentsByAgeParams) => {
  const response = await baseAPI.get<string>('reporting/students-by-age', {
    params: {
      ...(status !== 'all' ? { status } : {}),
      ...(ageAsOf ? { ageAsOf } : {}),
      ...(minAge !== undefined ? { minAge } : {}),
      ...(maxAge !== undefined ? { maxAge } : {}),
      format,
    },
    responseType: 'text',
  });
  return response.data;
};
